var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeamlessTransfer(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 565.173,
    height: 410,
    viewBox: "0 0 565.173 410",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "seamless-transfer",
    transform: "translate(0 0.524)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_330",
    "data-name": "Rectangle 330",
    width: 565,
    height: 410,
    transform: "translate(0.173 -0.524)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_281",
    "data-name": "Rectangle 281",
    width: 95.082,
    height: 179.745,
    transform: "translate(32.439 216.798)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_282",
    "data-name": "Rectangle 282",
    width: 95.082,
    height: 179.745,
    transform: "translate(4.222 216.798)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1000",
    "data-name": "Path 1000",
    d: "M92.275,253.178H10.66v-28.5H92.275Zm-80.612-1H91.272V225.683H11.663Z",
    transform: "translate(0.029 0.622)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1001",
    "data-name": "Path 1001",
    d: "M36.46,225.18H67.435v.712a4.964,4.964,0,0,1-4.964,4.964H41.414a4.964,4.964,0,0,1-4.964-4.964v-.712Z",
    transform: "translate(0.101 0.623)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1002",
    "data-name": "Path 1002",
    d: "M92.275,289.268H10.66v-28.5H92.275Zm-80.612-1H91.272V261.773H11.663Z",
    transform: "translate(0.029 0.721)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1003",
    "data-name": "Path 1003",
    d: "M36.46,261.27H67.435V262a4.964,4.964,0,0,1-4.964,4.964H41.414A4.964,4.964,0,0,1,36.46,262v-.732Z",
    transform: "translate(0.101 0.723)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1004",
    "data-name": "Path 1004",
    d: "M92.275,325.358H10.66V296.87H92.275Zm-80.612-1H91.272V297.873H11.663Z",
    transform: "translate(0.029 0.821)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1005",
    "data-name": "Path 1005",
    d: "M36.46,297.37H67.435v.712a4.964,4.964,0,0,1-4.964,4.934H41.414a4.964,4.964,0,0,1-4.964-4.964v-.712Z",
    transform: "translate(0.101 0.822)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1006",
    "data-name": "Path 1006",
    d: "M92.275,361.448H10.66V333H92.275Zm-80.612-1H91.272V334H11.663Z",
    transform: "translate(0.029 0.921)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1007",
    "data-name": "Path 1007",
    d: "M36.46,333.46H67.435v.712a4.964,4.964,0,0,1-4.964,4.964H41.414a4.964,4.964,0,0,1-4.964-4.964v-.712Z",
    transform: "translate(0.101 0.922)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_283",
    "data-name": "Rectangle 283",
    width: 103.284,
    height: 8.955,
    transform: "translate(0 210.07)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_284",
    "data-name": "Rectangle 284",
    width: 31.055,
    height: 8.955,
    transform: "translate(103.284 210.07)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_285",
    "data-name": "Rectangle 285",
    width: 4.994,
    height: 9.185,
    transform: "translate(4.222 396.543)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_286",
    "data-name": "Rectangle 286",
    width: 4.994,
    height: 9.185,
    transform: "translate(35.097 396.543)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_287",
    "data-name": "Rectangle 287",
    width: 4.994,
    height: 9.185,
    transform: "translate(91.482 396.543)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_288",
    "data-name": "Rectangle 288",
    width: 4.994,
    height: 9.185,
    transform: "translate(119.679 396.543)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1008",
    "data-name": "Path 1008",
    d: "M519.045,184.65c-4.773.11-7.651,5.545-7.892,10.308s1,9.637-.12,14.259c-1.484,5.866-6.688,10.288-8.022,16.185-1.6,7.019,2.517,13.908,3.008,21.058.251,3.47-.341,7.019.461,10.389a12.785,12.785,0,0,0,25.069-1c.852-5.395-1.775-10.96-.622-16.295.852-3.951,3.71-7.4,3.76-11.442.06-4.8-3.851-8.764-4.773-13.487s1.254-9.476,1.384-14.279c.221-8.624-3.67-15.192-12.274-15.693",
    transform: "translate(1.388 0.511)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1009",
    "data-name": "Path 1009",
    d: "M521.394,207.1a4.024,4.024,0,0,1,0,.762c0,.541-.08,1.274-.14,2.186-.14,1.945-.341,4.683-.592,8.022-.511,6.789-1.2,16.164-1.905,26.533s-1.274,19.754-1.685,26.543c-.211,3.369-.381,6.107-.5,8.022-.06.913-.11,1.645-.15,2.186a6.6,6.6,0,0,1-.08.762,4.162,4.162,0,0,1,0-.772c0-.542,0-1.263.07-2.186.08-1.945.2-4.693.351-8.022.331-6.8.852-16.185,1.554-26.553s1.444-19.744,2.006-26.533c.311-3.349.562-6.087.742-8.022.09-.923.17-1.645.221-2.186a6.25,6.25,0,0,1,.11-.742Z",
    transform: "translate(1.425 0.573)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1010",
    "data-name": "Path 1010",
    d: "M518.042,299.724h0a15.212,15.212,0,0,0,15.212-15.212V269.3H502.87v15.212a15.212,15.212,0,0,0,15.172,15.212Z",
    transform: "translate(1.388 0.745)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1011",
    "data-name": "Path 1011",
    d: "M502.87,276.761a2.837,2.837,0,0,1,.491.331l1.334,1,4.713,3.81h-.261l8.774-5.375h0l.14-.09.14.09,8.162,5.385H526.1l5.164-3.81,1.454-1a2.385,2.385,0,0,1,.552-.331,2.6,2.6,0,0,1-.461.441l-1.394,1.133L526.4,282.3l-.12.1-.13-.09-8.213-5.315h.261l-8.814,5.295-.14.08-.11-.1-4.593-3.951-1.253-1.133C503,276.931,502.85,276.781,502.87,276.761Z",
    transform: "translate(1.388 0.764)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1012",
    "data-name": "Path 1012",
    d: "M502.87,273.731a2.238,2.238,0,0,1,.491.331l1.334,1,4.713,3.821h-.261l8.774-5.375h0l.14-.09.14.09,8.162,5.385H526.1l5.164-3.81,1.454-1c.351-.241.531-.351.552-.331a2.4,2.4,0,0,1-.461.431l-1.394,1.133-5.014,3.961-.12.09-.13-.08-8.213-5.315h.261l-8.814,5.3-.14.08-.11-.1-4.593-3.951-1.253-1.133C503,273.9,502.85,273.751,502.87,273.731Z",
    transform: "translate(1.388 0.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1013",
    "data-name": "Path 1013",
    d: "M502.87,279.851a2.237,2.237,0,0,1,.491.331l1.334,1,4.713,3.81h-.261l8.774-5.375h0l.14-.09.14.09,8.162,5.385H526.1l5.164-3.81,1.454-1c.351-.241.531-.351.552-.331a2.4,2.4,0,0,1-.461.431l-1.394,1.133-5.014,3.961-.12.09-.13-.08-8.213-5.315h.261l-8.814,5.3-.14.08-.11-.1-4.593-4.011-1.253-1.123C503,280,502.85,279.871,502.87,279.851Z",
    transform: "translate(1.388 0.773)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1014",
    "data-name": "Path 1014",
    d: "M539.623,376.26l9.707,27.857h-4.853l-17-27.857Z",
    transform: "translate(1.456 1.04)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1015",
    "data-name": "Path 1015",
    d: "M484.047,376.26l-9.707,27.857h4.853l17-27.857Z",
    transform: "translate(1.309 1.04)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_289",
    "data-name": "Rectangle 289",
    width: 77.604,
    height: 77.604,
    transform: "translate(539.856 378.002) rotate(180)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_290",
    "data-name": "Rectangle 290",
    width: 77.604,
    height: 77.604,
    transform: "translate(564.173 378.002) rotate(180)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1016",
    "data-name": "Path 1016",
    d: "M557.7,372.376H490.35V305H557.7Zm-66.343-1h65.34V306h-65.34Z",
    transform: "translate(1.354 0.843)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1017",
    "data-name": "Path 1017",
    d: "M556.8,325.881c-21.9-.642-44.041-.471-65.962,0a.271.271,0,0,0,0,.531c21.92.441,44.061.612,65.962,0a.241.241,0,0,0,0-.471Z",
    transform: "translate(1.354 0.9)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1018",
    "data-name": "Path 1018",
    d: "M522,316.385a1.9,1.9,0,1,0,1.9-1.885,1.9,1.9,0,0,0-1.9,1.885Z",
    transform: "translate(1.441 0.87)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1019",
    "data-name": "Path 1019",
    d: "M549.18,346.615a1.885,1.885,0,1,0,.549-1.34A1.885,1.885,0,0,0,549.18,346.615Z",
    transform: "translate(1.516 0.953)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1020",
    "data-name": "Path 1020",
    d: "M61.2,185.43l9.627,24.628-5.986-.03L60.05,194.9Z",
    transform: "translate(0.166 0.513)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1021",
    "data-name": "Path 1021",
    d: "M28.439,162.74,25.13,209.92l34.154.712,3.841-47.892Z",
    transform: "translate(0.069 0.451)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1022",
    "data-name": "Path 1022",
    d: "M31.838,166.531,29.09,205.8l25.39,1.193L58.03,166.3Z",
    transform: "translate(0.08 0.46)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1023",
    "data-name": "Path 1023",
    d: "M37.4,172.07,35.34,199.676h14l2.477-27.606Z",
    transform: "translate(0.098 0.476)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_291",
    "data-name": "Rectangle 291",
    width: 110.243,
    height: 108.318,
    transform: "translate(401.896 28.67)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_292",
    "data-name": "Rectangle 292",
    width: 102.512,
    height: 102.512,
    transform: "translate(405.727 31.628)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_293",
    "data-name": "Rectangle 293",
    width: 33.442,
    height: 33.442,
    transform: "translate(440.262 66.164)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_294",
    "data-name": "Rectangle 294",
    width: 105.661,
    height: 162.487,
    rx: 7.54,
    transform: "translate(205.361 104.857) rotate(-85.83)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1024",
    "data-name": "Path 1024",
    d: "M348.512,34.033a11.221,11.221,0,1,1-2.689-8.167,11.211,11.211,0,0,1,2.689,8.167Z",
    transform: "translate(0.9 0.062)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1025",
    "data-name": "Path 1025",
    d: "M350.772,45.874h-.852a11.722,11.722,0,1,1,12.535-10.84h0a11.742,11.742,0,0,1-11.682,10.84Zm0-22.432a10.709,10.709,0,1,0,10.679,11.492h0a10.72,10.72,0,0,0-9.907-11.462q-.391-.03-.782-.03Z",
    transform: "translate(0.936 0.063)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1026",
    "data-name": "Path 1026",
    d: "M221.9,67.741l-.652,9.025-.923-.06.592-8.173-2.126-.16.06-.822Z",
    transform: "translate(0.604 0.188)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1027",
    "data-name": "Path 1027",
    d: "M230.538,76.593l-.06.822-6.307-.461.05-.662,4.011-3.389c1.093-.923,1.334-1.514,1.374-2.126.08-1-.612-1.745-2.006-1.845a3.079,3.079,0,0,0-2.527.832l-.612-.622a4.011,4.011,0,0,1,3.279-1c1.825.14,2.918,1.143,2.808,2.647a3.74,3.74,0,0,1-1.685,2.707l-3.279,2.788Z",
    transform: "translate(0.619 0.189)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1028",
    "data-name": "Path 1028",
    d: "M240.1,75.739l-1.795-.13-.18,2.356-.923-.06.17-2.367-5.074-.371V74.5l5.2-5.615,1,.08-5.014,5.475,3.911.281.15-2.086.9.07-.16,2.086,1.8.13Z",
    transform: "translate(0.641 0.192)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1029",
    "data-name": "Path 1029",
    d: "M253.851,76.739l-1.8-.13-.17,2.417-.923-.07.17-2.367-5.074-.371v-.672l5.2-5.605,1,.07-5.014,5.475,3.911.281.15-2.076.892.06-.15,2.086,1.8.13Z",
    transform: "translate(0.679 0.195)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1030",
    "data-name": "Path 1030",
    d: "M261.708,77.019c-.11,1.524-1.263,2.647-3.46,2.487a4.683,4.683,0,0,1-3.139-1.394l.5-.7a3.851,3.851,0,0,0,2.687,1.243c1.524.11,2.387-.572,2.467-1.665s-.582-1.935-2.868-2.1l-1.9-.13.792-4.472,4.924.351-.06.822-4.111-.3-.542,2.848,1.163.08C260.876,74.291,261.829,75.434,261.708,77.019Z",
    transform: "translate(0.704 0.196)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1031",
    "data-name": "Path 1031",
    d: "M270.578,77.638a2.818,2.818,0,0,1-3.269,2.537c-2.4-.181-3.57-1.925-3.359-4.773.221-3.008,2.006-4.522,4.442-4.352a4.151,4.151,0,0,1,2.106.652l-.431.712a3.2,3.2,0,0,0-1.715-.552c-1.945-.14-3.279,1-3.46,3.46v.732a2.888,2.888,0,0,1,2.858-1.344,2.738,2.738,0,0,1,2.828,2.928Zm-.913-.05c.08-1.173-.732-2.006-2.126-2.106a2.106,2.106,0,0,0-2.457,1.8c-.07,1,.692,2.006,2.246,2.1a2.006,2.006,0,0,0,2.336-1.795Z",
    transform: "translate(0.729 0.198)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1032",
    "data-name": "Path 1032",
    d: "M282.848,78.629c-.11,1.5-1.284,2.577-3.46,2.427a4.733,4.733,0,0,1-3.149-1.394l.5-.7a3.9,3.9,0,0,0,2.707,1.243c1.494.11,2.367-.521,2.447-1.645s-.632-1.835-2.3-2.006h-.642l.05-.682,2.717-2.938-4.6-.341.06-.822,5.786.421-.05.662-2.778,3.008C282.016,76.1,282.948,77.195,282.848,78.629Z",
    transform: "translate(0.763 0.199)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1033",
    "data-name": "Path 1033",
    d: "M291.848,79.178a2.818,2.818,0,0,1-3.269,2.547c-2.4-.18-3.57-1.925-3.359-4.773.221-3.008,2.006-4.522,4.442-4.352a4.242,4.242,0,0,1,2.106.642l-.431.722a3.169,3.169,0,0,0-1.715-.552c-1.945-.14-3.279,1-3.46,3.46V77.6a2.888,2.888,0,0,1,2.848-1.344,2.727,2.727,0,0,1,2.838,2.918Zm-.913,0c.08-1.183-.732-2.006-2.126-2.106a2.076,2.076,0,0,0-2.447,1.8c-.08,1,.682,2.006,2.236,2.1a2.005,2.005,0,0,0,2.336-1.835Z",
    transform: "translate(0.787 0.202)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1034",
    "data-name": "Path 1034",
    d: "M300.559,73.471l-.05.662-4.372,8.022-1-.07,4.3-7.9-4.633-.341-.12,1.685-.913-.07L294,73Z",
    transform: "translate(0.811 0.203)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1035",
    "data-name": "Path 1035",
    d: "M313.389,74.411l-.05.652-4.372,8.022-.963-.06,4.292-7.9-4.623-.341-.12,1.685-.913-.06.181-2.507Z",
    transform: "translate(0.846 0.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1036",
    "data-name": "Path 1036",
    d: "M321.739,81.539c-.11,1.594-1.534,2.487-3.68,2.326s-3.4-1.243-3.279-2.828a2.256,2.256,0,0,1,1.9-2.086,2.056,2.056,0,0,1-1.274-2.086c.11-1.464,1.424-2.286,3.329-2.146s3.1,1.143,3.008,2.607a2.005,2.005,0,0,1-1.584,1.875,2.266,2.266,0,0,1,1.584,2.336Zm-.943-.08c.08-1.1-.822-1.865-2.417-2.006s-2.577.511-2.657,1.614.8,1.885,2.4,2.006,2.6-.491,2.677-1.614Zm-2.366-2.717c1.4.1,2.286-.461,2.357-1.444s-.772-1.695-2.116-1.795-2.266.5-2.346,1.5.682,1.634,2.106,1.735Z",
    transform: "translate(0.869 0.208)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1037",
    "data-name": "Path 1037",
    d: "M330.608,80.1c-.221,3.008-2.006,4.532-4.452,4.352a4.011,4.011,0,0,1-2.1-.642l.421-.712a3.209,3.209,0,0,0,1.725.552c1.935.14,3.269-1,3.449-3.46v-.732a2.908,2.908,0,0,1-2.868,1.334A2.728,2.728,0,0,1,324,77.877a2.808,2.808,0,0,1,3.279-2.537C329.636,75.511,330.809,77.265,330.608,80.1Zm-1.143-1.875c.07-1-.682-2.006-2.236-2.1a2.005,2.005,0,0,0-2.346,1.785c-.08,1.183.742,2.006,2.126,2.106a2.086,2.086,0,0,0,2.457-1.795Z",
    transform: "translate(0.894 0.209)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1038",
    "data-name": "Path 1038",
    d: "M340.009,76.35l-.662,9.025-.923-.07.582-8.2-2.1-.1.06-.822Z",
    transform: "translate(0.93 0.212)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1039",
    "data-name": "Path 1039",
    d: "M348.658,85.193l-.06.822-6.307-.461V84.9l4.011-3.389c1.083-.933,1.324-1.524,1.364-2.136.08-1-.6-1.735-2.006-1.835a3.008,3.008,0,0,0-2.527.822l-.622-.612a4.011,4.011,0,0,1,3.279-1c1.825.13,2.918,1.143,2.808,2.647-.06.852-.391,1.6-1.685,2.7l-3.279,2.788Z",
    transform: "translate(0.945 0.213)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1040",
    "data-name": "Path 1040",
    d: "M356.828,84.019c-.11,1.5-1.284,2.577-3.45,2.427a4.743,4.743,0,0,1-3.159-1.424l.5-.7a3.951,3.951,0,0,0,2.717,1.243c1.484.11,2.356-.521,2.447-1.645s-.632-1.835-2.306-2.006h-.642l.05-.682,2.717-2.938L351.112,78l.06-.822,5.776.421v.652l-2.778,3.008C356.016,81.492,356.939,82.585,356.828,84.019Z",
    transform: "translate(0.967 0.215)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_295",
    "data-name": "Rectangle 295",
    width: 3.921,
    height: 72.249,
    transform: "matrix(0.073, -0.997, 0.997, 0.073, 287.7, 92.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_296",
    "data-name": "Rectangle 296",
    width: 3.921,
    height: 37.052,
    transform: "matrix(0.073, -0.997, 0.997, 0.073, 322.214, 102.709)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_266",
    "data-name": "Group 266",
    transform: "translate(218.279 36.713)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_297",
    "data-name": "Rectangle 297",
    width: 30.388,
    height: 22.698,
    rx: 4.972,
    transform: "translate(1.585 0) rotate(4.004)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1041",
    "data-name": "Path 1041",
    d: "M217.39,53.406l.11-1.444L233.043,53.1a3.269,3.269,0,1,0,.471-6.518L218,45.444l.11-1.444,15.563,1.133a4.723,4.723,0,0,1-.682,9.416Z",
    transform: "translate(0.6 0.123)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_298",
    "data-name": "Rectangle 298",
    width: 1.454,
    height: 10.709,
    transform: "translate(237.839 50.97) rotate(-85.78)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    "data-name": "Rectangle 299",
    width: 77.965,
    height: 6.688,
    transform: "translate(224.102 18.883) rotate(4.17)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1042",
    "data-name": "Path 1042",
    d: "M271.854,408.267l-111.788-.511a24.367,24.367,0,0,1-24.247-24.467L137,102.927A24.367,24.367,0,0,1,161.481,78.67l111.828.521a24.357,24.357,0,0,1,24.247,24.457l-1.183,280.362a24.367,24.367,0,0,1-24.517,24.257Z",
    transform: "translate(0.375 0.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1043",
    "data-name": "Path 1043",
    d: "M273.088,88.831l-21.68-.09a5.385,5.385,0,0,0-5.295,5.475v3.931a5.4,5.4,0,0,1-5.295,5.485l-42.256-.2a5.4,5.4,0,0,1-5.244-5.525V93.975a5.4,5.4,0,0,0-5.194-5.535h-7.631l-18.972-.09a17.047,17.047,0,0,0-17.137,16.987L143.22,378.99a17.047,17.047,0,0,0,16.987,17.137l111.607.511a17.047,17.047,0,0,0,17.137-16.987L290.1,106a17.047,17.047,0,0,0-17.017-17.167Z",
    transform: "translate(0.395 0.245)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1044",
    "data-name": "Path 1044",
    d: "M209.753,369.646a2.326,2.326,0,1,1-2.3-2.005A2.156,2.156,0,0,1,209.753,369.646Z",
    transform: "translate(0.566 1.016)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1045",
    "data-name": "Path 1045",
    d: "M216.873,369.676a2.336,2.336,0,1,1-2.3-2.006,2.156,2.156,0,0,1,2.3,2.006Z",
    transform: "translate(0.586 1.016)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1046",
    "data-name": "Path 1046",
    d: "M224.013,369.706a2.326,2.326,0,1,1-2.3-2.005,2.146,2.146,0,0,1,2.3,2.005Z",
    transform: "translate(0.606 1.016)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1047",
    "data-name": "Path 1047",
    d: "M257.765,332.59l-80.281-.371c-.832,0-1.5-.9-1.494-2.006l.09-21.008a1.812,1.812,0,0,1,1.514-2.006l80.281.371c.832,0,1.5.9,1.494,2.006l-.09,21.008a1.815,1.815,0,0,1-1.514,2.005Z",
    transform: "translate(0.486 0.849)",
    fill: "#2c4e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1048",
    "data-name": "Path 1048",
    d: "M466.665,408.267l-111.828-.511a24.367,24.367,0,0,1-24.247-24.467l1.183-280.362A24.367,24.367,0,0,1,356.251,78.67l111.828.521a24.357,24.357,0,0,1,24.247,24.457l-1.183,280.362a24.367,24.367,0,0,1-24.477,24.257Z",
    transform: "translate(0.913 0.219)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1049",
    "data-name": "Path 1049",
    d: "M467.9,88.831l-21.68-.09a5.385,5.385,0,0,0-5.295,5.475v3.931a5.4,5.4,0,0,1-5.295,5.485l-42.256-.2a5.4,5.4,0,0,1-5.234-5.525V94.015a5.4,5.4,0,0,0-5.244-5.535h-7.631l-18.972-.09a17.047,17.047,0,0,0-17.137,16.987L338,378.96A17.047,17.047,0,0,0,354.987,396.1l111.607.511a17.047,17.047,0,0,0,17.137-16.987l1.163-273.653a17.047,17.047,0,0,0-17-17.137Z",
    transform: "translate(0.933 0.245)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1050",
    "data-name": "Path 1050",
    d: "M404.563,369.646a2.326,2.326,0,1,1-2.3-2.005A2.156,2.156,0,0,1,404.563,369.646Z",
    transform: "translate(1.104 1.016)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1051",
    "data-name": "Path 1051",
    d: "M411.683,369.676a2.336,2.336,0,1,1-2.3-2.006,2.156,2.156,0,0,1,2.3,2.006Z",
    transform: "translate(1.124 1.016)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1052",
    "data-name": "Path 1052",
    d: "M418.793,369.706a2.326,2.326,0,1,1-2.3-2.005,2.146,2.146,0,0,1,2.3,2.005Z",
    transform: "translate(1.143 1.016)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    "data-name": "Rectangle 300",
    width: 108.93,
    height: 112.389,
    rx: 8.76,
    transform: "translate(357.855 142.614)",
    fill: "#455a64",
    stroke: "#455a64",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1053",
    "data-name": "Path 1053",
    d: "M435.013,270.17v10.86h-2.507v-8.874H430.32V270.15Z",
    transform: "translate(1.188 0.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1054",
    "data-name": "Path 1054",
    d: "M439.156,280.579a4.563,4.563,0,0,1-1.655-1.935,7.922,7.922,0,0,1,0-6.017,4.5,4.5,0,0,1,1.655-1.935,4.4,4.4,0,0,1,2.417-.672,4.351,4.351,0,0,1,2.407.672,4.462,4.462,0,0,1,1.665,1.935,8.022,8.022,0,0,1,0,6.017,4.513,4.513,0,0,1-1.665,1.935,4.432,4.432,0,0,1-2.407.672A4.492,4.492,0,0,1,439.156,280.579Zm4.011-2.316a6.518,6.518,0,0,0,0-5.295,1.855,1.855,0,0,0-3.119,0,6.518,6.518,0,0,0,0,5.295,1.855,1.855,0,0,0,3.119,0Z",
    transform: "translate(1.206 0.747)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1055",
    "data-name": "Path 1055",
    d: "M452.629,270.922a2.316,2.316,0,0,1,.521,1.635,2.666,2.666,0,0,1-.281,1.284,1.905,1.905,0,0,1-.792.822,2.487,2.487,0,0,1-1.183.281,2.868,2.868,0,0,1-.672-.08,1.633,1.633,0,0,1-.552-.231l.381-.752a1.394,1.394,0,0,0,.822.221,1.193,1.193,0,0,0,.892-.331,1.394,1.394,0,0,0,.361-.953,1.524,1.524,0,0,1-1.1.391,1.624,1.624,0,0,1-.772-.17,1.294,1.294,0,0,1-.552-.481,1.264,1.264,0,0,1-.2-.722,1.354,1.354,0,0,1,.221-.782,1.374,1.374,0,0,1,.6-.511,2.006,2.006,0,0,1,.852-.18,1.905,1.905,0,0,1,1.454.562Zm-.832,1.334a.592.592,0,0,0,.211-.471.642.642,0,0,0-.2-.481.853.853,0,0,0-.572-.18.772.772,0,0,0-.531.18.652.652,0,0,0,0,1,.8.8,0,0,0,.541.18.772.772,0,0,0,.552-.231Z",
    transform: "translate(1.241 0.748)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1056",
    "data-name": "Path 1056",
    d: "M456.649,270.922a2.316,2.316,0,0,1,.521,1.635,2.667,2.667,0,0,1-.281,1.284,1.905,1.905,0,0,1-.792.822,2.487,2.487,0,0,1-1.183.281,2.936,2.936,0,0,1-.672-.08,1.636,1.636,0,0,1-.551-.231l.381-.752a1.394,1.394,0,0,0,.822.221,1.193,1.193,0,0,0,.892-.331,1.394,1.394,0,0,0,.361-.953,1.524,1.524,0,0,1-1.1.391,1.644,1.644,0,0,1-.772-.17,1.294,1.294,0,0,1-.552-.481,1.264,1.264,0,0,1-.2-.722,1.354,1.354,0,0,1,.221-.782,1.434,1.434,0,0,1,.6-.511,2.005,2.005,0,0,1,.852-.18A1.905,1.905,0,0,1,456.649,270.922Zm-.832,1.334a.592.592,0,0,0,.211-.471.642.642,0,0,0-.2-.481.852.852,0,0,0-.572-.18.772.772,0,0,0-.531.18.652.652,0,0,0,0,1,.812.812,0,0,0,.551.18.762.762,0,0,0,.542-.231Z",
    transform: "translate(1.252 0.748)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    "data-name": "Rectangle 301",
    width: 7.781,
    height: 0.983,
    transform: "translate(450.61 277.205)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    "data-name": "Rectangle 302",
    width: 40.161,
    height: 1.243,
    transform: "translate(364.393 274.106)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    "data-name": "Rectangle 303",
    width: 24.377,
    height: 1.243,
    transform: "translate(364.393 278.087)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_222",
    "data-name": "Ellipse 222",
    cx: 30.725,
    cy: 30.725,
    r: 30.725,
    transform: "translate(378.672 164.996)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1057",
    "data-name": "Path 1057",
    d: "M423.695,187.11c.321.3-6.077,7.581-14.289,16.265-1.524,1.6-3.008,3.149-4.4,4.6l-.5.531-.541-.481c-6.628-5.876-11.261-10.308-11.03-10.579s5.265,3.71,12.033,9.436l-1,.06c1.374-1.484,2.838-3.008,4.352-4.663C416.465,193.608,423.374,186.809,423.695,187.11Z",
    transform: "translate(1.085 0.518)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1058",
    "data-name": "Path 1058",
    d: "M449.785,335.39l-80.291-.321A1.815,1.815,0,0,1,368,333.063l.09-21a1.812,1.812,0,0,1,1.514-2.006l80.281.371c.832,0,1.5.9,1.494,2.006l-.09,21.008A1.788,1.788,0,0,1,449.785,335.39Z",
    transform: "translate(1.016 0.857)",
    fill: "#2c4e7f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1059",
    "data-name": "Path 1059",
    d: "M449.785,328.68l-80.291-.371A1.815,1.815,0,0,1,368,326.3l.09-21A1.812,1.812,0,0,1,369.6,303.3l80.281.371a1.815,1.815,0,0,1,1.494,2.006l-.09,21C451.289,327.777,450.607,328.68,449.785,328.68Z",
    transform: "translate(1.016 0.839)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1060",
    "data-name": "Path 1060",
    d: "M390.951,320.851l-2.006-3.159h-1.083v3.159h-1V313.12h2.547a2.748,2.748,0,0,1,2.006.632,2.2,2.2,0,0,1,.662,1.675,2.166,2.166,0,0,1-.531,1.514,2.507,2.507,0,0,1-1.524.722l2.106,3.189Zm-3.1-3.841h1.454c1.133,0,1.7-.5,1.7-1.494s-.572-1.494-1.7-1.494h-1.454Z",
    transform: "translate(1.068 0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1061",
    "data-name": "Path 1061",
    d: "M394.233,313.932v2.647h2.938v.762h-2.938v2.677H397.5v.812H393.23V313.1H397.5v.812Z",
    transform: "translate(1.085 0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1062",
    "data-name": "Path 1062",
    d: "M404.527,313.742a3.53,3.53,0,0,1,1.273,1.9h-1a2.617,2.617,0,0,0-1-1.223,2.808,2.808,0,0,0-1.614-.451,2.487,2.487,0,0,0-2.3,1.424,3.5,3.5,0,0,0-.351,1.6,3.46,3.46,0,0,0,.351,1.594,2.507,2.507,0,0,0,2.3,1.414,2.738,2.738,0,0,0,1.614-.461,2.527,2.527,0,0,0,1-1.223h1a3.51,3.51,0,0,1-1.273,1.905,3.72,3.72,0,0,1-2.336.7,3.66,3.66,0,0,1-1.915-.5,3.43,3.43,0,0,1-1.273-1.4,4.322,4.322,0,0,1-.471-2.006,4.4,4.4,0,0,1,.471-2.056,3.429,3.429,0,0,1,1.3-1.394,3.66,3.66,0,0,1,1.915-.5A3.721,3.721,0,0,1,404.527,313.742Z",
    transform: "translate(1.1 0.865)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1063",
    "data-name": "Path 1063",
    d: "M408.113,313.932v2.647h2.9v.762h-2.938v2.677h3.269v.812H407.07V313.1h4.272v.812Z",
    transform: "translate(1.124 0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1064",
    "data-name": "Path 1064",
    d: "M413.653,313.12v7.731h-1V313.12Z",
    transform: "translate(1.139 0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1065",
    "data-name": "Path 1065",
    d: "M415.753,313.12l2.357,6.628,2.387-6.628h1.093l-2.848,7.731h-1.253l-2.838-7.731Z",
    transform: "translate(1.145 0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1066",
    "data-name": "Path 1066",
    d: "M423.573,313.932v2.647h2.938v.762h-2.938v2.677h3.269v.812H422.57V313.1h4.272v.812Z",
    transform: "translate(1.166 0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1067",
    "data-name": "Path 1067",
    d: "M434.157,319.016a3.279,3.279,0,0,1-1.384,1.354,4.843,4.843,0,0,1-2.206.471H428.11V313.11h2.457a4.843,4.843,0,0,1,2.206.461,3.2,3.2,0,0,1,1.384,1.344A4.693,4.693,0,0,1,434.157,319.016Zm-1.354.15a2.9,2.9,0,0,0,.8-2.2,2.938,2.938,0,0,0-.792-2.2,3.149,3.149,0,0,0-2.326-.792h-1.374v5.956h1.374a3.168,3.168,0,0,0,2.316-.762Z",
    transform: "translate(1.182 0.866)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1068",
    "data-name": "Path 1068",
    d: "M152.739,108c-.12.351-3.169,28.188-3.169,28.188l11.742-2.066,3.008-23Z",
    transform: "translate(0.413 0.3)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1069",
    "data-name": "Path 1069",
    d: "M149.572,136.229l-.882-.521,2.667-28.047,1.344.371Z",
    transform: "translate(0.41 0.299)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_223",
    "data-name": "Ellipse 223",
    cx: 0.541,
    cy: 0.541,
    r: 0.541,
    transform: "translate(158.226 112.08)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1070",
    "data-name": "Path 1070",
    d: "M142.563,151.216l22.522,5.9-3.439-27.987h0l-.451-1.274-8.263-1.273,1-6.1a4.954,4.954,0,0,1,6.147-3.911l2.707.712a7.019,7.019,0,0,1,4.462,3.6c1.574,3.068,3.1,6.418,2.948,6.127h0l12.033,32.76a12.4,12.4,0,0,1-1.334,13.216c-3.9,5.014-13.3,1.534-17.719.682L134.32,167.31Z",
    transform: "translate(0.371 0.323)",
    fill: "#c67761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1071",
    "data-name": "Path 1071",
    d: "M57.29,199.733a15.4,15.4,0,0,1,.07-20.306L81.978,151.5l6.588,18.431c-.451.291-19.173,20.366-19.173,20.366l16.094,20.055a11.522,11.522,0,0,1,1.905,10.97l-.722,2.948a7.09,7.09,0,0,1-9.8,4.783l-4.522-2.006a1,1,0,0,1-.411-1.394h0a1,1,0,0,1,.8-.441H78.88a2.8,2.8,0,0,0,2.707-2.116h0Z",
    transform: "translate(0.148 0.42)",
    fill: "#c67761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1072",
    "data-name": "Path 1072",
    d: "M65.91,186.62a9.175,9.175,0,0,1,2.156,1.835,6.117,6.117,0,0,1,1.715,2.266,11.03,11.03,0,0,1-2.086-1.9C66.582,187.733,65.79,186.72,65.91,186.62Z",
    transform: "translate(0.182 0.517)",
    fill: "#9b4e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1073",
    "data-name": "Path 1073",
    d: "M71.74,391.545s25.33-80.331,25.821-82.928c.491-2.357-9.175-60.166-10.389-75.117l34.164,1.273V235l14.53.8L122.831,400.079H107.1l1.564-54.5c-9.7,26.072-23.595,52.555-23.595,52.555Z",
    transform: "translate(0.198 0.646)",
    fill: "#c67761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1074",
    "data-name": "Path 1074",
    d: "M108,364.873c0-.5.191-18.26.191-18.26s6.939-19.754,7.079-19.253S108,364.873,108,364.873Z",
    transform: "translate(0.298 0.905)",
    fill: "#9b4e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1075",
    "data-name": "Path 1075",
    d: "M95.538,110.065c-1.815-2.517-5.926-2.346-8.243-.281s-3.129,5.345-3.219,8.443c-.08,2.878.13,6.307-2.2,8.022a25.631,25.631,0,0,1-3.139,1.484,5.736,5.736,0,0,0-2.918,5.014c0,1.534.622,3.3-.381,4.452a7.149,7.149,0,0,1-2.006,1.223A6.017,6.017,0,0,0,71,144.1a10.93,10.93,0,0,0,1.424,4.843s16.225-.16,23.615,0c0,0-.14-26.012-.511-38.827",
    transform: "translate(0.196 0.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1076",
    "data-name": "Path 1076",
    d: "M121.749,143.506c0-1.825.5-9.085.5-9.085s6.759-.662,7.24-7.531.241-22.723.241-22.723L117.488,97.86,103.85,108.239l1.354,35.337Z",
    transform: "translate(0.287 0.271)",
    fill: "#c67761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1077",
    "data-name": "Path 1077",
    d: "M128.2,115.662a.862.862,0,1,1-.852-.892.872.872,0,0,1,.852.892Z",
    transform: "translate(0.349 0.318)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1078",
    "data-name": "Path 1078",
    d: "M129.009,114.713c-.11.11-.732-.451-1.655-.511s-1.624.391-1.725.261.08-.261.381-.471a2.226,2.226,0,0,1,2.7.191C129.009,114.432,129.1,114.663,129.009,114.713Z",
    transform: "translate(0.347 0.315)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1079",
    "data-name": "Path 1079",
    d: "M118.295,115.552a.862.862,0,1,1-.852-.892A.882.882,0,0,1,118.295,115.552Z",
    transform: "translate(0.322 0.318)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1080",
    "data-name": "Path 1080",
    d: "M118.839,114.6c-.11.11-.742-.441-1.665-.5s-1.614.381-1.715.251.07-.261.381-.471a2.2,2.2,0,0,1,1.374-.361,2.256,2.256,0,0,1,1.314.562C118.809,114.332,118.89,114.553,118.839,114.6Z",
    transform: "translate(0.319 0.315)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1081",
    "data-name": "Path 1081",
    d: "M122.07,122.633a5.9,5.9,0,0,1,1.5-.18c.241,0,.461-.05.511-.221a1.394,1.394,0,0,0-.12-.752c-.2-.632-.4-1.284-.612-2.006A35.871,35.871,0,0,1,122,114.34a34.243,34.243,0,0,1,1.725,5.014c.211.692.4,1.354.592,2.006a1.634,1.634,0,0,1,.08,1,.6.6,0,0,1-.411.341,1.463,1.463,0,0,1-.4,0,5.194,5.194,0,0,1-1.514-.07Z",
    transform: "translate(0.337 0.317)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1082",
    "data-name": "Path 1082",
    d: "M122.224,134.329a16.365,16.365,0,0,1-8.844-3.169s2.006,5.074,8.674,4.853Z",
    transform: "translate(0.313 0.364)",
    fill: "#9b4e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1083",
    "data-name": "Path 1083",
    d: "M94.23,114.715c.08-.491-.07.531,0-.241h0a25.481,25.481,0,0,1,.441-2.778c3.81-14.3,16.114-16.846,18.541-16.826,2.607,0,10.028-.191,14.2,5.014a13.638,13.638,0,0,1,2.377,13.648h0l-10.86-1.925c.8-2.7-.3-6.077-.933-7.651l-.06-.07c-2.056,10.278-13.116,11.231-13.116,11.231l-.14,16.405c-8.022-1.173-10.669-10.84-10.479-16.8Z",
    transform: "translate(0.26 0.263)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1084",
    "data-name": "Path 1084",
    d: "M101.61,116.038a4.4,4.4,0,0,1,1,.07,14.55,14.55,0,0,0,2.617,0,14.1,14.1,0,0,0,3.78-.822,13.186,13.186,0,0,0,7.019-6.017,14.119,14.119,0,0,0,1.4-3.59,27.546,27.546,0,0,0,.471-3.57,3.2,3.2,0,0,1,.12,1,11.972,11.972,0,0,1-.231,2.677,13.362,13.362,0,0,1-12.565,10.77,11.362,11.362,0,0,1-2.667-.191,2.828,2.828,0,0,1-.953-.331Z",
    transform: "translate(0.28 0.283)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1085",
    "data-name": "Path 1085",
    d: "M104.954,122.646c.07-1,.552-3.5.2-4.472s-1.424-1.193-2.617-1.183a2.667,2.667,0,0,0-2.567,2.567,3.47,3.47,0,0,0,1.444,3.008,3.941,3.941,0,0,0,3.439.191",
    transform: "translate(0.276 0.324)",
    fill: "#c67761"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1086",
    "data-name": "Path 1086",
    d: "M103.666,121.288c0-.07-.331.07-.772-.07a1.384,1.384,0,0,1-.882-1.344,1,1,0,0,1,.241-.812.892.892,0,0,1,.682-.191c.461.06.782.191.812.11s-.2-.291-.752-.471a1.253,1.253,0,0,0-1,.18,1.4,1.4,0,0,0-.461,1.2,2.006,2.006,0,0,0,.431,1.173,1.454,1.454,0,0,0,.892.511C103.425,121.649,103.716,121.328,103.666,121.288Z",
    transform: "translate(0.28 0.328)",
    fill: "#9b4e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1087",
    "data-name": "Path 1087",
    d: "M100.8,122.461a4.442,4.442,0,0,0-.12,1.113,1.514,1.514,0,0,0,.5,1,1.635,1.635,0,0,0,1.263.4,1.675,1.675,0,0,0,1.1-.722,1.544,1.544,0,0,0,.221-1.083,2.889,2.889,0,0,0-.411-1c.06,0,.541.17.772,1a1.835,1.835,0,0,1-.17,1.4,2.006,2.006,0,0,1-3.109.421,1.815,1.815,0,0,1-.541-1.314C100.32,122.762,100.771,122.411,100.8,122.461Z",
    transform: "translate(0.277 0.339)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1088",
    "data-name": "Path 1088",
    d: "M95.845,118.787a4.374,4.374,0,0,1-.943-1.193,8.564,8.564,0,0,1-1-3.53,8.463,8.463,0,0,1,.511-3.65,3.128,3.128,0,0,1,.752-1.324,14.169,14.169,0,0,0-.742,4.934,14.36,14.36,0,0,0,1.424,4.763Z",
    transform: "translate(0.259 0.302)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1089",
    "data-name": "Path 1089",
    d: "M68.642,146a1.785,1.785,0,0,1-.261-.441A5.315,5.315,0,0,1,68,144.1a6.017,6.017,0,0,1,.211-2.377,5.656,5.656,0,0,1,1.685-2.637c.9-.792,2.216-1.143,3.008-2.106a2.617,2.617,0,0,0,.562-1.8A17.83,17.83,0,0,0,73.174,133a5.345,5.345,0,0,1,.06-2.417,5.415,5.415,0,0,1,1.314-2.166A17.438,17.438,0,0,1,78.84,125.5a8.022,8.022,0,0,0,3.58-3.319,11.522,11.522,0,0,0,.552-4.593,10.238,10.238,0,0,1,3.008-7.451,7.45,7.45,0,0,1,5.014-2.006,5.835,5.835,0,0,1,1.484.2,2.086,2.086,0,0,1,.491.181,11.714,11.714,0,0,0-2.006-.18,7.481,7.481,0,0,0-4.8,2.086,9.937,9.937,0,0,0-2.788,7.18,11.783,11.783,0,0,1-.562,4.813,8.524,8.524,0,0,1-3.79,3.56,17.047,17.047,0,0,0-4.182,2.808,4.943,4.943,0,0,0-1.2,1.955,4.813,4.813,0,0,0-.07,2.206,16.825,16.825,0,0,1,.281,2.236,3.109,3.109,0,0,1-.692,2.1c-1,1.083-2.306,1.384-3.149,2.116a5.335,5.335,0,0,0-1.665,2.457,6.017,6.017,0,0,0-.281,2.266,7.831,7.831,0,0,0,.582,1.9Z",
    transform: "translate(0.188 0.3)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1090",
    "data-name": "Path 1090",
    d: "M119.312,123.18a1.9,1.9,0,0,1,1.464,0,1.464,1.464,0,0,1,.862,1.153,1.223,1.223,0,0,1-.682,1.233,1.574,1.574,0,0,1-1.394-.16,1.655,1.655,0,0,1-.832-1,1,1,0,0,1,.592-1.113",
    transform: "translate(0.328 0.341)",
    fill: "#9b4e3d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1091",
    "data-name": "Path 1091",
    d: "M118.66,121.9a7.49,7.49,0,0,0,1.645,2.106,7.862,7.862,0,0,0,2.507,1c0,.07-.311.18-.852.16a3.61,3.61,0,0,1-2.006-.712,3.57,3.57,0,0,1-1.253-1.685C118.57,122.251,118.59,121.91,118.66,121.9Z",
    transform: "translate(0.327 0.338)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1092",
    "data-name": "Path 1092",
    d: "M89.956,145.005c-3.9.943-6.087,2.2-11.9,8.513L62.47,170.977,83.889,186.55l8.764-11.9,1.855,26.072s-4.843,5.956-9.155,22.532c-3.48,13.4-3.8,27.075-4.793,37.473l-2.647,65.46,60.978,1.665s-2.3-19.383-1.2-60.687c.622-23.495-3.169-46.969-5.224-53.467l-3.139-17a15.533,15.533,0,0,1,2.657-8.764c4.954-6.959,1.424-15.182,1.424-15.182l16.275,6.017,10.75-24.237-22.221-8.353c-8.022-3.309-17.578-2.828-17.578-2.828l-16.917-.2s-7.932-.612-13.758,1.815",
    transform: "translate(0.172 0.396)",
    fill: "#f99746",
    stroke: "#f99746",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1093",
    "data-name": "Path 1093",
    d: "M123.044,400.456V399l-16.114-.7v6.1l1,.06c4.422.261,22.5,1,25.46.12C136.662,403.554,123.044,400.456,123.044,400.456Z",
    transform: "translate(0.295 1.101)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_267",
    "data-name": "Group 267",
    transform: "translate(107.265 400.743)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1094",
    "data-name": "Path 1094",
    d: "M112.726,404.253a5.585,5.585,0,0,0-2.006-3.419,5.415,5.415,0,0,0-3.75-1.183v4.482Z",
    transform: "translate(-106.97 -399.638)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_268",
    "data-name": "Group 268",
    transform: "translate(107.205 403.312)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1095",
    "data-name": "Path 1095",
    d: "M129.7,402.2s4.763,1.384,4.171,2.176-18.892.712-26.964,0v-.361l21.339.261S128.77,402.23,129.7,402.2Z",
    transform: "translate(-106.91 -402.2)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1096",
    "data-name": "Path 1096",
    d: "M106.69,404h.271l.792.05,2.908.14c2.467.09,5.866.18,9.616.2s7.16,0,9.627-.12l2.908-.11h1.063a1.1,1.1,0,0,0-.271,0h-3.71c-2.457,0-5.856.08-9.616.07s-7.15-.09-9.606-.15l-2.918-.07h-.792Z",
    transform: "translate(0.294 1.117)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1097",
    "data-name": "Path 1097",
    d: "M128.21,404.507a6.6,6.6,0,0,1,.552-1.394,6.759,6.759,0,0,1,1-1.113,2.156,2.156,0,0,0-1.163,1,2.246,2.246,0,0,0-.391,1.5Z",
    transform: "translate(0.354 1.111)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1098",
    "data-name": "Path 1098",
    d: "M123.51,402.094a3.47,3.47,0,0,0,.5-.612,1.765,1.765,0,0,0,.351-.722,3.787,3.787,0,0,0-.511.612C123.61,401.733,123.46,402.064,123.51,402.094Z",
    transform: "translate(0.341 1.108)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1099",
    "data-name": "Path 1099",
    d: "M122.22,401.4a2.747,2.747,0,0,0,.562-.371c.281-.241.471-.481.441-.521s-.291.12-.572.371S122.18,401.362,122.22,401.4Z",
    transform: "translate(0.337 1.107)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1100",
    "data-name": "Path 1100",
    d: "M121.4,399.89a2.006,2.006,0,0,0,.842.11c.461,0,.832,0,.832-.09a2.006,2.006,0,0,0-.832-.11C121.781,399.8,121.4,399.83,121.4,399.89Z",
    transform: "translate(0.335 1.105)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1101",
    "data-name": "Path 1101",
    d: "M121.13,398.82a1.544,1.544,0,0,0,.933.281,1.644,1.644,0,0,0,1-.13,6.806,6.806,0,0,0-1-.07,6.7,6.7,0,0,0-.933-.08Z",
    transform: "translate(0.334 1.102)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1102",
    "data-name": "Path 1102",
    d: "M124.05,400.7a3.008,3.008,0,0,0,1,0,6.013,6.013,0,0,0,1.1-.231,2.935,2.935,0,0,0,.622-.261.572.572,0,0,0,.261-.321.411.411,0,0,0-.16-.411,1.9,1.9,0,0,0-2.336.542,1.765,1.765,0,0,0-.331.692.511.511,0,0,0,0,.281,2.677,2.677,0,0,1,.471-.882,1.905,1.905,0,0,1,.882-.572,1.625,1.625,0,0,1,1.223.09c.16.12.1.311-.08.421a3.007,3.007,0,0,1-.582.251,8.3,8.3,0,0,1-1.063.271A9.784,9.784,0,0,0,124.05,400.7Z",
    transform: "translate(0.342 1.104)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1103",
    "data-name": "Path 1103",
    d: "M124.324,400.756a1,1,0,0,0,.12-.712,1.584,1.584,0,0,0-.281-.762,1,1,0,0,0-.852-.521.411.411,0,0,0-.321.471,1.063,1.063,0,0,0,.18.461,2.726,2.726,0,0,0,.481.622,1.454,1.454,0,0,0,.582.421,5.765,5.765,0,0,1-.481-.511,3.7,3.7,0,0,1-.431-.622c-.14-.221-.231-.612,0-.652s.521.231.682.441a1.7,1.7,0,0,1,.291.672A3.779,3.779,0,0,1,124.324,400.756Z",
    transform: "translate(0.339 1.102)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1104",
    "data-name": "Path 1104",
    d: "M107,399.61h1.183a5.2,5.2,0,0,1,2.577,1.083,5.134,5.134,0,0,1,1.6,2.286c.241.682.271,1.143.3,1.143a.9.9,0,0,0,0-.321,3.72,3.72,0,0,0-.17-.872,4.853,4.853,0,0,0-4.3-3.449,4.009,4.009,0,0,0-.882,0A1.071,1.071,0,0,0,107,399.61Z",
    transform: "translate(0.295 1.104)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1105",
    "data-name": "Path 1105",
    d: "M114.72,402.71a9.406,9.406,0,0,0,2.336.221,8.956,8.956,0,0,0,2.346-.2c0-.05-1,0-2.336,0S114.73,402.65,114.72,402.71Z",
    transform: "translate(0.317 1.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1106",
    "data-name": "Path 1106",
    d: "M111.59,402.67s.08.221.191.461.16.461.221.451.08-.251,0-.531S111.62,402.63,111.59,402.67Z",
    transform: "translate(0.308 1.113)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1107",
    "data-name": "Path 1107",
    d: "M110.42,401.2a1.043,1.043,0,0,0,.221.371c.16.17.331.281.371.241s-.06-.211-.231-.371S110.45,401.16,110.42,401.2Z",
    transform: "translate(0.305 1.109)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1108",
    "data-name": "Path 1108",
    d: "M108.73,400.52c0,.06.221.06.461.14s.4.211.441.17-.09-.261-.381-.351S108.71,400.47,108.73,400.52Z",
    transform: "translate(0.3 1.107)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1109",
    "data-name": "Path 1109",
    d: "M107.53,400.2c0,.05.07.13.2.191s.261.05.281,0-.08-.13-.211-.191S107.55,400.15,107.53,400.2Z",
    transform: "translate(0.297 1.106)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1110",
    "data-name": "Path 1110",
    d: "M85.425,399.024l.612-1.344-14.41-7.24-2.537,5.575.882.471c3.931,2.005,20.115,10.128,23.174,10.539C96.566,407.457,85.425,399.024,85.425,399.024Z",
    transform: "translate(0.191 1.079)",
    fill: "#e8505b"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_269",
    "data-name": "Group 269",
    transform: "translate(69.391 392.803)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1111",
    "data-name": "Path 1111",
    d: "M74.434,398.288a5.545,5.545,0,0,0-.451-3.961,5.4,5.4,0,0,0-2.928-2.607L69.2,395.8Z",
    transform: "translate(-69.2 -391.72)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_270",
    "data-name": "Group 270",
    transform: "translate(69.281 396.784)",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1112",
    "data-name": "Path 1112",
    d: "M90.77,403.361s3.78,3.219,2.908,3.69S76.149,400.012,69.09,396l.17-.311,19.363,8.975S89.9,403.02,90.77,403.361Z",
    transform: "translate(-69.09 -395.69)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_1113",
    "data-name": "Path 1113",
    d: "M69,395.57l.241.14.7.371,2.6,1.314c2.206,1.093,5.264,2.567,8.684,4.121s6.548,2.9,8.824,3.831l2.707,1.093.742.291a1.1,1.1,0,0,0,.261.08,1.847,1.847,0,0,0-.251-.12l-.722-.321-2.677-1.143c-2.266-1-5.385-2.336-8.8-3.881s-6.488-3.008-8.7-4.071L70,396l-.722-.341Z",
    transform: "translate(0.19 1.093)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1114",
    "data-name": "Path 1114",
    d: "M88.47,404.864a5.887,5.887,0,0,1,1.063-1,6.819,6.819,0,0,1,1.364-.612,2.176,2.176,0,0,0-1.474.451,2.136,2.136,0,0,0-.953,1.163Z",
    transform: "translate(0.244 1.115)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1115",
    "data-name": "Path 1115",
    d: "M85.16,400.732a3.13,3.13,0,0,0,.712-.351c.361-.241.642-.471.612-.511a1.769,1.769,0,0,0-.722.351C85.391,400.462,85.13,400.692,85.16,400.732Z",
    transform: "translate(0.235 1.105)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1116",
    "data-name": "Path 1116",
    d: "M84.26,399.571c0,.05.321,0,.672-.11s.632-.241.612-.291-.311,0-.672.11S84.25,399.521,84.26,399.571Z",
    transform: "translate(0.233 1.103)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1117",
    "data-name": "Path 1117",
    d: "M84.14,397.86a2.064,2.064,0,0,0,.722.441,1.8,1.8,0,0,0,.792.271,1.965,1.965,0,0,0-.712-.441,1.855,1.855,0,0,0-.8-.271Z",
    transform: "translate(0.232 1.1)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1118",
    "data-name": "Path 1118",
    d: "M84.32,396.78a1.725,1.725,0,0,0,.742.632,1.655,1.655,0,0,0,.933.281,5.18,5.18,0,0,0-.842-.451A4.643,4.643,0,0,0,84.32,396.78Z",
    transform: "translate(0.233 1.097)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1119",
    "data-name": "Path 1119",
    d: "M86.23,399.682a2.878,2.878,0,0,0,.943.421,5.617,5.617,0,0,0,1.093.231,3.011,3.011,0,0,0,.682,0,.541.541,0,0,0,.361-.19.411.411,0,0,0,0-.441,1.905,1.905,0,0,0-2.356-.461,1.946,1.946,0,0,0-.592.491.6.6,0,0,0-.14.241,2.948,2.948,0,0,1,.792-.6,1.915,1.915,0,0,1,1-.16,1.625,1.625,0,0,1,1.083.582c.09.18,0,.331-.251.351a3.335,3.335,0,0,1-.632,0A7.022,7.022,0,0,1,87.2,400C86.6,399.822,86.24,399.662,86.23,399.682Z",
    transform: "translate(0.238 1.103)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1120",
    "data-name": "Path 1120",
    d: "M86.453,399.846a1.174,1.174,0,0,0,.4-.6,1.725,1.725,0,0,0,.06-.8,1,1,0,0,0-.572-.832c-.231-.07-.762.391-.8.572s.271.08.291.221a3.008,3.008,0,0,0,.18.772,1.524,1.524,0,0,0,.371.622,6.918,6.918,0,0,1-.241-.672,3.431,3.431,0,0,1-.13-.732c0-.261,0-.652.281-.592s.381.421.441.682a1.574,1.574,0,0,1,0,.722,3.6,3.6,0,0,1-.281.642Z",
    transform: "translate(0.236 1.099)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1121",
    "data-name": "Path 1121",
    d: "M71.14,391.72a6.253,6.253,0,0,1,1.063.521,5.255,5.255,0,0,1,1.915,2.006,5.144,5.144,0,0,1,.521,2.748c-.06.732-.231,1.153-.191,1.163s.06-.09.13-.291a4.241,4.241,0,0,0,.2-.862,4.8,4.8,0,0,0-3.309-5.254.862.862,0,0,0-.331-.03Z",
    transform: "translate(0.196 1.083)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1122",
    "data-name": "Path 1122",
    d: "M76.89,397.7a9.117,9.117,0,0,0,2.006,1.153,9.025,9.025,0,0,0,2.216.782c0-.05-1-.421-2.136-.953S76.92,397.65,76.89,397.7Z",
    transform: "translate(0.212 1.099)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1123",
    "data-name": "Path 1123",
    d: "M74.05,396.38v1a.743.743,0,0,0,.18-.5C74.23,396.581,74.09,396.36,74.05,396.38Z",
    transform: "translate(0.204 1.096)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1124",
    "data-name": "Path 1124",
    d: "M73.58,394.56a1.847,1.847,0,0,0,.06.431c.06.221.18.391.231.371s0-.221-.05-.441S73.63,394.54,73.58,394.56Z",
    transform: "translate(0.203 1.091)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M72.32,393.25c0,.05.18.14.361.311s.281.361.331.341,0-.271-.2-.481S72.32,393.2,72.32,393.25Z",
    transform: "translate(0.2 1.087)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M71.35,392.46a.37.37,0,0,0,.11.251c.11.1.221.16.251.12s0-.15-.11-.251S71.39,392.43,71.35,392.46Z",
    transform: "translate(0.197 1.085)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1127",
    "data-name": "Path 1127",
    d: "M144.88,148.78a4.269,4.269,0,0,1-.622.05h-1.8l-6.638.08-21.89.08-21.9.01-6.638-.08h-1.8a4.546,4.546,0,0,1-.632-.05,2.647,2.647,0,0,1,.632-.06h1.8l6.638-.09,21.9-.07,21.89.07,6.638.09h1.8A2.506,2.506,0,0,1,144.88,148.78Z",
    transform: "translate(0.229 0.412)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1128",
    "data-name": "Path 1128",
    d: "M158.584,158.41a5.839,5.839,0,0,1-.862.05h-2.477l-9.1.08-30,.08-30.013-.08-9.125-.03H74.532a5.835,5.835,0,0,1-.862-.05,4.887,4.887,0,0,1,.862-.06h2.477l9.1-.09,30.013-.07,30,.07,9.1.09h2.477a4.882,4.882,0,0,1,.893.01Z",
    transform: "translate(0.203 0.438)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1129",
    "data-name": "Path 1129",
    d: "M151.922,169.941s-.311,0-.9.05h-2.567l-9.436.08-31.086.08-31.146-.08L67.3,170H64.732c-.582,0-.892,0-.892-.05a5.212,5.212,0,0,1,.892-.06H67.3l9.436-.09,31.146-.07,31.136.07,9.436.09h2.567A5.28,5.28,0,0,1,151.922,169.941Z",
    transform: "translate(0.176 0.47)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1130",
    "data-name": "Path 1130",
    d: "M133.782,181.771a8.925,8.925,0,0,1-1.6.1l-4.362.08c-3.69.05-8.784.08-14.42.08s-10.72-.03-14.38-.03l-4.372-.08a8.922,8.922,0,0,1-1.6-.1,8.924,8.924,0,0,1,1.6-.1l4.372-.08c3.69-.05,8.784-.08,14.41-.08s10.73,0,14.42.08l4.362.08a8.926,8.926,0,0,1,1.574.05Z",
    transform: "translate(0.257 0.503)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1131",
    "data-name": "Path 1131",
    d: "M129.558,193.351a7.921,7.921,0,0,1-1.4.1l-3.8.08c-3.219.05-7.661.08-12.565.08s-9.356,0-12.565-.08l-3.81-.08a7.72,7.72,0,0,1-1.394-.1,6.7,6.7,0,0,1,1.394-.1l3.81-.09c3.209,0,7.651-.07,12.565-.07s9.346,0,12.565.07l3.8.09a6.869,6.869,0,0,1,1.4.1Z",
    transform: "translate(0.26 0.534)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1132",
    "data-name": "Path 1132",
    d: "M131.785,187.881a7.74,7.74,0,0,1-1.494.1l-4.091.09c-3.449,0-8.213.07-13.477.07s-10.028,0-13.477-.07L95.154,188a7.744,7.744,0,0,1-1.494-.1,8.932,8.932,0,0,1,1.494-.1l4.091-.08c3.45,0,8.213-.08,13.477-.08s10.028,0,13.477.08l4.091.08A8.937,8.937,0,0,1,131.785,187.881Z",
    transform: "translate(0.259 0.519)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1133",
    "data-name": "Path 1133",
    d: "M134.244,176a10.67,10.67,0,0,1-1.634.1l-4.452.08c-3.76.05-8.965.08-14.7.08s-10.94,0-14.71-.08l-4.452-.08a10.67,10.67,0,0,1-1.634-.1,9.716,9.716,0,0,1,1.634-.11l4.452-.08c3.77,0,8.965-.07,14.71-.07s10.94,0,14.7.07l4.452.08a9.719,9.719,0,0,1,1.634.11Z",
    transform: "translate(0.256 0.487)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1134",
    "data-name": "Path 1134",
    d: "M91.551,176a18.711,18.711,0,0,1-3.239.191c-2.006,0-4.763.07-7.812.07s-5.826,0-7.822-.07A18.711,18.711,0,0,1,69.44,176a20.985,20.985,0,0,1,3.239-.18c2.006-.05,4.763-.08,7.822-.08s5.816,0,7.812.08A20.985,20.985,0,0,1,91.551,176Z",
    transform: "translate(0.192 0.487)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1135",
    "data-name": "Path 1135",
    d: "M151.03,175.371a29.233,29.233,0,0,1-5.465.261,29.3,29.3,0,0,1-5.475-.261,29.3,29.3,0,0,1,5.475-.261,29.234,29.234,0,0,1,5.465.261Z",
    transform: "translate(0.387 0.485)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1136",
    "data-name": "Path 1136",
    d: "M155.289,164a5.014,5.014,0,0,1-.882.06l-2.517.05-9.3.08-30.634.08-30.644-.08-9.306-.13L69.5,164a5.015,5.015,0,0,1-.882-.06,8.584,8.584,0,0,1,.882,0l2.517-.05,9.3-.08,30.644-.08,30.634.08,9.3.08,2.517.05a8.582,8.582,0,0,1,.882.06Z",
    transform: "translate(0.189 0.453)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1137",
    "data-name": "Path 1137",
    d: "M156.937,153.2a4.916,4.916,0,0,1-.8.05l-2.3.05-8.453.08-27.877.08-27.887-.08-8.443-.08-2.3-.05a4.916,4.916,0,0,1-.8-.05,4.112,4.112,0,0,1,.8-.06h2.3l8.443-.09,27.887-.07,27.877.07,8.453.09h2.3A4.112,4.112,0,0,1,156.937,153.2Z",
    transform: "translate(0.216 0.424)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1138",
    "data-name": "Path 1138",
    d: "M162.56,281.884V182.41l6.829,5.515,5.565-5.515,5.9,4.853,5.565-4.853,5.565,5.184,6.719-5.184,4.914,4.853,5.4-4.853,5.4,5.345,6.548-5.345,5.565,5.184,5.9-5.184,6.217,5.345,5.575-5.345,5.4,4.693,5.9-4.693,6.217,4.693,5.4-4.693v99.474Z",
    transform: "translate(0.449 0.505)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1139",
    "data-name": "Path 1139",
    d: "M162.56,281.885h7.521l21.2-.06,75.869-.11-.221.221V182.462l.431.2-5.4,4.683-.16.14-.16-.12-6.227-4.693h.321l-1.775,1.334-4.161,3.309-.17.14-.16-.15-5.4-4.683h.351l-5.575,5.345-.17.16-.17-.15-6.227-5.345h.341l-5.9,5.174-.18.15-.17-.15-5.565-5.184h.371l-6.558,5.345-.17.14-.16-.16-5.4-5.345h.341l-5.4,4.853-.17.15-.17-.16q-2.487-2.467-4.914-4.853h.331l-6.718,5.174-.16.12-.15-.14-5.565-5.174h.311l-5.545,4.873-.15.13-.15-.13-5.9-4.853h.311l-5.575,5.5-.14.14-.16-.12-6.809-5.515.351-.17c-.05,29.962-.08,54.8-.11,72.2,0,8.694,0,15.513-.06,20.166v.09c0-4.653,0-11.452-.06-20.115,0-17.4-.07-42.286-.11-72.3V182l.351.281,6.829,5.505h-.3c1.815-1.8,3.65-3.63,5.565-5.515l.14-.15.16.14,5.9,4.843h-.3l5.565-4.863.16-.14.16.15,5.575,5.174h-.321l6.718-5.184.17-.13.15.15,4.914,4.843h-.341l5.4-4.853.17-.16.17.16,5.4,5.345H214.4c2.156-1.775,4.342-3.55,6.548-5.355l.17-.14.16.16q2.768,2.557,5.565,5.174h-.341l5.9-5.174.17-.15.17.15,6.217,5.335h-.341l5.565-5.345.17-.16.18.16,5.4,4.683H249.6l4.161-3.309,1.735-1.374.16-.13.16.12,6.227,4.693h-.331l5.4-4.683.431-.381V282.136h-.221l-76.009-.11-21.3-.09h-5.545C163.192,281.905,162.56,281.885,162.56,281.885Z",
    transform: "translate(0.448 0.503)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1140",
    "data-name": "Path 1140",
    d: "M216.94,222.681c0,.14-9.747.261-21.77.261s-21.77-.12-21.77-.261,9.747-.271,21.77-.271S216.94,222.53,216.94,222.681Z",
    transform: "translate(0.479 0.615)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1141",
    "data-name": "Path 1141",
    d: "M216.94,234c0,.15-9.747.261-21.77.261s-21.77-.11-21.77-.261,9.747-.261,21.77-.261S216.94,233.85,216.94,234Z",
    transform: "translate(0.479 0.647)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1142",
    "data-name": "Path 1142",
    d: "M216.94,245.311c0,.15-9.747.261-21.77.261s-21.77-.11-21.77-.261,9.747-.261,21.77-.261S216.94,245.17,216.94,245.311Z",
    transform: "translate(0.479 0.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1143",
    "data-name": "Path 1143",
    d: "M216.94,256.631c0,.14-9.747.261-21.77.261s-21.77-.12-21.77-.261,9.747-.261,21.77-.261S216.94,256.49,216.94,256.631Z",
    transform: "translate(0.479 0.709)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1144",
    "data-name": "Path 1144",
    d: "M252.661,222.441a53.308,53.308,0,0,1-7.521.261,53.4,53.4,0,0,1-7.531-.261,55.27,55.27,0,0,1,7.531-.261,55.149,55.149,0,0,1,7.521.261Z",
    transform: "translate(0.656 0.615)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1145",
    "data-name": "Path 1145",
    d: "M252.661,234a53.308,53.308,0,0,1-7.521.261A53.394,53.394,0,0,1,237.61,234a55.273,55.273,0,0,1,7.531-.261,55.146,55.146,0,0,1,7.521.261Z",
    transform: "translate(0.656 0.646)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1146",
    "data-name": "Path 1146",
    d: "M252.661,245.541a53.3,53.3,0,0,1-7.521.261,53.4,53.4,0,0,1-7.531-.261,55.278,55.278,0,0,1,7.531-.261,55.153,55.153,0,0,1,7.521.261Z",
    transform: "translate(0.656 0.678)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1147",
    "data-name": "Path 1147",
    d: "M252.661,257.091a55.15,55.15,0,0,1-7.521.261,55.272,55.272,0,0,1-7.531-.261,55.272,55.272,0,0,1,7.531-.261,55.159,55.159,0,0,1,7.521.261Z",
    transform: "translate(0.656 0.71)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1148",
    "data-name": "Path 1148",
    d: "M162.64,268.292v-3.139l104.277-4.733v8.363Z",
    transform: "translate(0.449 0.72)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    "data-name": "Rectangle 304",
    width: 40.161,
    height: 1.243,
    transform: "translate(173.086 205.256)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    "data-name": "Rectangle 305",
    width: 24.377,
    height: 1.243,
    transform: "translate(173.086 209.227)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1149",
    "data-name": "Path 1149",
    d: "M230.893,198.56v10.89h-2.527v-8.864H226.19V198.58Z",
    transform: "translate(0.624 0.55)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1150",
    "data-name": "Path 1150",
    d: "M235.006,208.969a4.5,4.5,0,0,1-1.655-1.935,7.922,7.922,0,0,1,0-6.017A4.5,4.5,0,0,1,235.006,199a4.452,4.452,0,0,1,6.478,1.935,7.922,7.922,0,0,1,0,6.017,4.372,4.372,0,0,1-1.655,1.935,4.663,4.663,0,0,1-4.823,0Zm4.011-2.316a6.518,6.518,0,0,0,0-5.295,1.855,1.855,0,0,0-3.119,0,6.518,6.518,0,0,0,0,5.295,1.855,1.855,0,0,0,3.119,0Z",
    transform: "translate(0.643 0.549)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1151",
    "data-name": "Path 1151",
    d: "M248.5,199.312a2.316,2.316,0,0,1,.521,1.635,2.737,2.737,0,0,1-.281,1.294,1.875,1.875,0,0,1-.792.812,2.4,2.4,0,0,1-1.183.281,3.01,3.01,0,0,1-.682-.08,2.115,2.115,0,0,1-.552-.221l.381-.762a1.434,1.434,0,0,0,.832.231,1.183,1.183,0,0,0,.892-.341,1.344,1.344,0,0,0,.351-1,1.5,1.5,0,0,1-1.1.4,1.685,1.685,0,0,1-.772-.181,1.293,1.293,0,0,1-.752-1.2,1.364,1.364,0,0,1,.832-1.294,2.146,2.146,0,0,1,2.306.381Zm-.832,1.344a.632.632,0,0,0,.211-.481.592.592,0,0,0-.211-.471.9.9,0,0,0-1.093,0,.652.652,0,0,0,0,1,.772.772,0,0,0,.542.18A.832.832,0,0,0,247.666,200.655Z",
    transform: "translate(0.677 0.55)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1152",
    "data-name": "Path 1152",
    d: "M252.519,199.312a2.316,2.316,0,0,1,.521,1.635,2.738,2.738,0,0,1-.281,1.294,1.875,1.875,0,0,1-.792.812,2.4,2.4,0,0,1-1.183.281,3.007,3.007,0,0,1-.682-.08,2.116,2.116,0,0,1-.551-.221l.381-.762a1.434,1.434,0,0,0,.832.231,1.183,1.183,0,0,0,.892-.341,1.344,1.344,0,0,0,.351-1,1.5,1.5,0,0,1-1.1.4,1.685,1.685,0,0,1-.772-.181,1.334,1.334,0,0,1-.752-1.2,1.364,1.364,0,0,1,.832-1.294,1.934,1.934,0,0,1,.852-.18,1.905,1.905,0,0,1,1.454.612Zm-.832,1.344a.632.632,0,0,0,.211-.481.592.592,0,0,0-.211-.471.9.9,0,0,0-1.093,0,.652.652,0,0,0,0,1,.772.772,0,0,0,.542.18.832.832,0,0,0,.552-.231Z",
    transform: "translate(0.688 0.55)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    "data-name": "Rectangle 306",
    width: 7.781,
    height: 0.983,
    transform: "translate(245.917 205.397)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1153",
    "data-name": "Path 1153",
    d: "M190.35,39.7,168.028,26.131a1.945,1.945,0,0,0-2.928,1.635l-.13,7.42C134.977,36.93,128.7,65.84,128.7,65.84l12.976,3.55c5.014-21.5,23.063-21.69,23.063-21.69l-.12,6.488a1.945,1.945,0,0,0,2.908,1.725L190.3,43.047a1.945,1.945,0,0,0,.05-3.349Z",
    transform: "translate(0.355 0.073)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1154",
    "data-name": "Path 1154",
    d: "M540.191,133.915a11.23,11.23,0,0,1-1.7,8.654,19.865,19.865,0,0,1-6.638,6.067c-5.014,3.008-11.682,3.951-17.538,3.951.421-6.488,5.656-11.913,8.483-14.49,4.462-4.091,15.041-8.764,17.4-4.181",
    transform: "translate(1.42 0.366)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1155",
    "data-name": "Path 1155",
    d: "M510.17,162.859a9.617,9.617,0,0,1,9.135-3.089,12.805,12.805,0,0,1,8.022,5.686,5.4,5.4,0,0,1,1,4.412,4.131,4.131,0,0,1-3.269,2.587,8.543,8.543,0,0,1-4.292-.6c-4.693-1.755-8.915-4.312-10.679-9.025",
    transform: "translate(1.408 0.442)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1156",
    "data-name": "Path 1156",
    d: "M492.25,168.706a6.172,6.172,0,0,1,1.053-.592l2.918-1.494A33.914,33.914,0,0,1,506.439,163a20.647,20.647,0,0,1,10.74,1.093,14.47,14.47,0,0,1,2.9,1.584,8.842,8.842,0,0,1,.7.562c.16.13.231.2.221.221a19.112,19.112,0,0,0-14.5-3.008,36.45,36.45,0,0,0-10.148,3.47c-1.253.592-2.266,1.063-3.008,1.374A7.279,7.279,0,0,1,492.25,168.706Z",
    transform: "translate(1.359 0.451)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1157",
    "data-name": "Path 1157",
    d: "M532.533,138.16a4.316,4.316,0,0,1-.381.371c-.261.231-.672.572-1.133,1-1,.842-2.447,2.006-4.252,3.52-3.6,2.958-8.644,6.959-14.309,11.261s-10.88,8.082-14.7,10.76c-1.905,1.334-3.46,2.407-4.532,3.139l-1.253.822a2.56,2.56,0,0,1-.451.271,2.428,2.428,0,0,1,.4-.341l1.2-.892,4.462-3.249c3.77-2.738,8.955-6.548,14.62-10.84s10.719-8.273,14.38-11.161l4.322-3.419,1.193-.923a3.009,3.009,0,0,1,.431-.321Z",
    transform: "translate(1.357 0.383)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1158",
    "data-name": "Path 1158",
    d: "M502.242,158.356a22.482,22.482,0,0,0,5.615-19.754c-.371-1.775-1.263-3.79-3.008-4.111s-3.339,1.233-4.282,2.788a19.2,19.2,0,0,0,1.263,21.279",
    transform: "translate(1.375 0.373)",
    fill: "#455a64"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1159",
    "data-name": "Path 1159",
    d: "M503.968,142.56a4.88,4.88,0,0,1,.271,1.093,10.773,10.773,0,0,1,.221,1.314,16.716,16.716,0,0,1,.16,1.755,18.9,18.9,0,0,1,0,2.146,21.728,21.728,0,0,1-.2,2.447,25.36,25.36,0,0,1-1.434,5.445,24.561,24.561,0,0,1-2.7,4.944,19.329,19.329,0,0,1-1.554,1.905,16.711,16.711,0,0,1-1.5,1.524c-.461.461-.953.8-1.344,1.133a9.705,9.705,0,0,1-1.083.782,5.719,5.719,0,0,1-1,.582c-.05-.08,1.324-.923,3.2-2.717a19.886,19.886,0,0,0,1.444-1.534,22.1,22.1,0,0,0,1.494-1.905,25.067,25.067,0,0,0,2.627-4.873A25.6,25.6,0,0,0,504,151.254a23.828,23.828,0,0,0,.241-2.407,21.04,21.04,0,0,0,0-2.106C504.239,144.154,503.878,142.57,503.968,142.56Z",
    transform: "translate(1.363 0.395)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1160",
    "data-name": "Path 1160",
    d: "M257.765,325.88l-80.281-.371a1.815,1.815,0,0,1-1.494-2.005l.09-21a1.812,1.812,0,0,1,1.514-2.006l80.281.371c.832,0,1.5.9,1.494,2.005l-.09,21.008a1.815,1.815,0,0,1-1.514,2Z",
    transform: "translate(0.486 0.831)",
    fill: "#007cff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1161",
    "data-name": "Path 1161",
    d: "M208.615,316.171a2.176,2.176,0,0,1-.882.842,3.008,3.008,0,0,1-1.454.321,3.52,3.52,0,0,1-1.494-.3,2.768,2.768,0,0,1-1.053-.842,2.427,2.427,0,0,1-.451-1.223h1.173a1.584,1.584,0,0,0,.241.7,1.554,1.554,0,0,0,.6.562,1.885,1.885,0,0,0,1,.231,1.484,1.484,0,0,0,1.1-.391,1.3,1.3,0,0,0,.381-1,1.253,1.253,0,0,0-.271-.842,1.844,1.844,0,0,0-.662-.511,8.249,8.249,0,0,0-1.083-.4,12.267,12.267,0,0,1-1.294-.5,2.176,2.176,0,0,1-.832-.712,2.159,2.159,0,0,1,.892-3.179,3.189,3.189,0,0,1,1.4-.281,3.008,3.008,0,0,1,2.006.612,2.326,2.326,0,0,1,.852,1.544h-1.183a1.565,1.565,0,0,0-.511-.892,1.614,1.614,0,0,0-1.143-.391,1.565,1.565,0,0,0-1.063.351,1.223,1.223,0,0,0-.4,1,1.2,1.2,0,0,0,.261.8,1.694,1.694,0,0,0,.642.481,9.009,9.009,0,0,0,1.063.391,11.337,11.337,0,0,1,1.314.511,2.186,2.186,0,0,1,.852.722,2.216,2.216,0,0,1,.351,1.294A2.316,2.316,0,0,1,208.615,316.171Z",
    transform: "translate(0.561 0.853)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1162",
    "data-name": "Path 1162",
    d: "M211.443,309.652v2.908h3.229v.842h-3.229v2.958h3.57v.892H210.33V308.77h4.683v.882Z",
    transform: "translate(0.581 0.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1163",
    "data-name": "Path 1163",
    d: "M223.018,317.253h-1.093l-4.4-6.708v6.708h-1.1V308.77h1.1l4.4,6.708V308.77h1.093Z",
    transform: "translate(0.597 0.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1164",
    "data-name": "Path 1164",
    d: "M231.378,315.248a3.53,3.53,0,0,1-1.514,1.474,5.155,5.155,0,0,1-2.417.531h-2.7V308.77h2.7a5.275,5.275,0,0,1,2.417.511,3.5,3.5,0,0,1,1.514,1.464A5.124,5.124,0,0,1,231.378,315.248Zm-1.474.16a3.76,3.76,0,0,0,0-4.813,3.429,3.429,0,0,0-2.537-.862h-1.524v6.528h1.524a3.5,3.5,0,0,0,2.537-.852Z",
    transform: "translate(0.62 0.854)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeamlessTransfer);
export default __webpack_public_path__ + "static/media/seamless-transfer.f4ca50a5e81f12afb764631eaaef314f.svg";
export { ForwardRef as ReactComponent };